import { createSelector } from 'reselect';

import {
  createFailedRequestSelectorFor,
} from 'redux-flight-control';

import {
  LOAD_USER_PROFILE,
} from '../constants';

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- LOAD_USER_PROFILE --------------------------- */

export const loadUserProfileErrorSelector =
  createFailedRequestSelectorFor(LOAD_USER_PROFILE);


/* --------------------------- USER STORE SELECTORS --------------------------- */

const userStoreSelector = state => state.get('user');

export const userProfileSelector = createSelector(
  userStoreSelector,
  userStore => userStore.get('profile'),
);

export const usernameSelector = createSelector(
  userStoreSelector,
  userStore => userStore.get('username'),
);



// WEBPACK FOOTER //
// ./redux/user/selectors.js